/* unplugin-vue-components disabled */import { render } from "./ArrowIcon.vue?vue&type=template&id=4920a5d8&scoped=true"
const script = {}

import "./ArrowIcon.vue?vue&type=style&index=0&id=4920a5d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4920a5d8"]])

export default __exports__